import { API_URL, ASSETS, URL, PLATFORM_FEE } from '../config.js';
import { printdDate } from '../helper.js';
import View from './View';

class SingleOrderView extends View {
  _parentElement = document.querySelector('.main');
  _errorMessage = 'Order View Error Message';
  _message = 'Order View Success Message';

  addHandlerSaveAddress(handler) {
    const paymentForm = document.querySelector('.cart__payment--container');
    if (!paymentForm) return;

    paymentForm.addEventListener('submit', e => {
      e.preventDefault();
      e.stopImmediatePropagation();

      const dataArr = [...new FormData(paymentForm)];
      const data = Object.fromEntries(dataArr);
      data.size = document.querySelector(
        '.product__size--btn-selected',
      ).dataset.size;

      handler(data);
    });
  }

  _generateMarkup() {
    const order = this._data;

    let packageContains = order.packageContains?.map(
      el =>
        `<strong><span class="orderlist__status">${el.toUpperCase()}</span> </strong>`,
    );
    packageContains =
      packageContains.length > 0 ? packageContains.join('') : packageContains;

    return `      <div class="row order">
        <div class="order__head">
          <h2 class="order__heading">Order: #${order.id}</h2>
        </div>

        <div class="order__container">
          <div action="#" class="cart__payment--container">
            <!-- SHIPPING ADDRESS -->
            <div class="cart__payment--address">
              <div class="cart__items--container-single">
                <ul class="cart__items">
                  <li class="cart__item">
                    <a href="/product?${order.slug}" class="link">
                      <div class="cart__item--img">
                        <img
                          src="${ASSETS}images/product/${order.imageCover}"
                          alt="${order.tag}"
                        />
                      </div>
                    </a>
                    <div class="cart__item--detail">
                      <div class="">
                        <h3 class="cart__item--title">
                          ${order.brand}
                        </h3>
                        <h4 class="cart__item--tag">Opaque Casual Shirt</h4>
                        <div class="product__size--button">
                          <button
                            class="product__size--btn product__size--btn-selected orderlist__size"
                            data-size="${order.size}"
                          >
                            ${order.size}
                          </button>
                        </div>
                      </div>

                      <div class="cart__item--price">
                        <span
                          class="cart__item--discounted-price order__quantity"
                          >QTY: ${order.quantity}</span
                        >
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="order__detail">
                <h3 class="cart__payment--heading opacity--8">
                  Shipping Address
                </h3>
                <address class="paragraph opacity--9 address">
                  <strong>
                    ${order.shipAddress}
                  </strong>
                </address>
                <h3 class="cart__payment--heading opacity--8">Mobile:</h3>
                <p class="paragraph opacity--9">
                  <strong> ${order.mobile} </strong>
                </p>
                <h3 class="cart__payment--heading opacity--8">Email:</h3>
                <p class="paragraph opacity--9">
                  <strong>  ${order.email} </strong>
                </p>              
                <h3 class="cart__payment--heading opacity--8">Ordered On:</h3>
                <p class="paragraph opacity--9">
                  <strong>  ${order.orderedAt ? printdDate(order.orderedAt) : printdDate(order.createdAt)} </strong>
                </p>              
                <h3 class="cart__payment--heading opacity--8">
                  Package Contains:
                </h3>
                <p class="paragraph opacity--9">
                  ${packageContains}

                </p>

                <h3 class="cart__payment--heading opacity--8">
                  Delivery Status:
                </h3>
                <p class="paragraph opacity--9">
                                   
                  ${
                    order.deliveryDate
                      ? `<strong>Delivered on: <span class="orderlist__status orderlist__status--delivered">${printdDate(order.deliveryDate, true)}</span>                      
                      </strong>`
                      : `${
                          order.paymentMethod
                            ? `<strong>
                    Expected delivery on: ${printdDate(order.expectedDelivery)} | <span class="tag"> ${order.deliveryStatus}  </span>
                  </strong>`
                            : `<strong>
                    Payment status: ${order.deliveryStatus}
                  </strong>`
                        }`
                  } 
                </p>
              </div>
            </div>

            <!-- AMOUNT DETAILS -->
            <div class="cart__detail">
              <div class="cart__price--container">
                <p class="cart__mrp--total cart__label-value">
                  <span class="cart__mrp--total-label cart__label"
                    >Total MRP:</span
                  ><span class="cart__mrp--total-value cart__value">₹${order.mrp}</span>
                </p>
                <p class="cart__discount--total cart__label-value">
                  <span class="cart__discount--total-label cart__label"
                    >Discount on MRP:</span
                  ><span class="cart__discount--total-value cart__value"
                    >${order.mrp - order.price > 0 ? `- ₹${order.mrp - order.price}` : `0`}</span
                  >
                </p>
                ${
                  order.platformFee
                    ? `<p class="cart__platformfee cart__label-value">
                  <span class="cart__platformfee-label cart__label"
                    >Platform Fee:</span
                  ><span class="cart__platformfee-value cart__value">₹${order.platformFee}</span>
                </p>`
                    : ``
                } 
                ${
                  order.tax
                    ? `<p class="cart__tax cart__label-value">
                  <span class="cart__tax-label cart__label">Tax:</span
                  ><span class="cart__tax-value cart__value">₹${order.tax}</span>
                </p>`
                    : ``
                }

                <p class="cart__price--total cart__label-value">
                  <span class="cart__price--total-label">Total Amount:</span
                  ><span class="cart__price--total-value"
                    ><strong>₹${Math.round(order.amount ? order.amount : order.price + +`${+(order.tax ? order.tax : 0)}` + +`${order.platformFee ? order.platformFee : 0}`)}</strong></span
                  >
                </p>
              </div>

              <!-- PAYMENT OPTIONS -->

              <div class="cart__payment--options-container order__spec--detail">
                <h3
                  class="product__spec--title cart__payment--method opacity--5"
                >
                  Payment Method
                </h3>
                <ul class="cart__payment--options">
                  <li class="cart__payment--option">
                    <label class="margin__left--8px order__label"
                      >${order.paymentMethod.toUpperCase()}</label
                    >
                  </li>
                </ul>
              </div>
              ${
                order.paymentMethod === 'online'
                  ? `
              <div class="cart__payment--options-container order__spec--detail">
                <h3
                  class="product__spec--title cart__payment--method opacity--5"
                >
                  Payment ID
                </h3>
                <ul class="cart__payment--options">
                  <li class="cart__payment--option">
                    <label class="margin__left--8px order__label"
                      >${order.paymentId}</label
                    >
                  </li>
                </ul>
              </div>
                `
                  : ``
              }
              ${
                order.paymentMethod === 'cod'
                  ? `
                <div class="cart__payment--options-container order__spec--detail">
                <h3
                  class="product__spec--title cart__payment--method opacity--5"
                >
                  Paid Using
                </h3>
                <ul class="cart__payment--options">
                  <li class="cart__payment--option">
                    <label class="margin__left--8px order__label"
                      >${order.paidIn ? `${order.paidIn.toUpperCase()}` : `Payment Due`}</label
                    >
                    ${
                      order.paidOn
                        ? `
                    <p class="paragraph opacity--9">
                      <strong><span class="orderlist__status">${printdDate(order.paidOn, true)}</span> </strong>
                    </p>
                      
                      `
                        : ``
                    }

                  </li>
                </ul>
              </div>
                `
                  : ``
              }

            </div>
          </div>
        </div>

        
      </div>
    `;
  }
}

export default new SingleOrderView();
